import { useState, useEffect } from "react";
import SignaturePad from "./SignaturePad";

const BASE = "https://support.gs-group.fr/api";
const h = () => ({ "Content-Type":"application/json", Authorization:"Bearer "+localStorage.getItem("nexo_token") });
const JOURS = ["lundi","mardi","mercredi","jeudi","vendredi","samedi","dimanche"];
const JOURS_L = ["Lundi","Mardi","Mercredi","Jeudi","Vendredi","Samedi","Dimanche"];

export default function FicheConsigne({ T, intervention, onClose }) {
  const [form, setForm] = useState({
    numero_client_1:"",numero_client_2:"",numero_client_3:"",
    numero_transmetteur:"",mot_de_passe_telesurveilleur:"",code_sous_contrainte:"",
    email_telesurveillance:"support.technique@gs-group.fr",email_client:intervention.client_email||"",
    horaires:{},signature_technicien:"",signature_client:""
  });
  const [saving, setSaving]     = useState(false);
  const [zones, setZones]       = useState([{id:1,designation:"",localisation:"",type:"PIR",notes:""}]);
  const [saved, setSaved]       = useState(false);
  const [envoyee, setEnvoyee]   = useState(false);
  const [step, setStep]         = useState("form"); // form | signatures | done
  const [errors, setErrors]     = useState({});

  useEffect(()=>{
    fetch(`${BASE}/fiche-consigne/${intervention.id}`,{headers:h()}).then(r=>r.json()).then(d=>{
      if (d) {
        setForm(p=>({...p,...d,horaires:typeof d.horaires==="string"?JSON.parse(d.horaires):d.horaires||{}}));
        if (d.envoyee) setEnvoyee(true);
      }
    }).catch(()=>{});
  },[]);

  const upF = (k,v) => setForm(p=>({...p,[k]:v}));
  const upH = (jour,field,val) => setForm(p=>({...p,horaires:{...p.horaires,[jour]:{...(p.horaires[jour]||{}),[field]:val}}}));

  const validate = () => {
    const e={};
    if (!form.numero_transmetteur) e.numero_transmetteur="Obligatoire";
    if (!form.numero_client_1) e.numero_client_1="Au moins un numéro requis";
    setErrors(e);
    return Object.keys(e).length===0;
  };

  const save = async (valide=false) => {
    if (valide && !validate()) return;
    setSaving(true);
    const res = await fetch(`${BASE}/fiche-consigne/${intervention.id}`,{
      method:"POST",headers:h(),
      body:JSON.stringify({...form,zones,validee:valide})
    }).then(r=>r.json());
    setSaving(false);
    if (valide && res.envoyee) {
      setEnvoyee(true);
      setStep("done");
    } else {
      setSaved(true);
      setTimeout(()=>setSaved(false),2000);
    }
  };

  const openPDF = async () => {
    const token = localStorage.getItem("nexo_token");
    const res = await fetch(`${BASE}/fiche-consigne/${intervention.id}/pdf`,{headers:h()});
    const html = await res.text();
    const win = window.open("about:blank","_blank");
    win.document.open(); win.document.write(html); win.document.close();
    setTimeout(()=>win.print(),600);
  };

  const inp = (key,placeholder="",type="text") => (
    <div>
      <input type={type} value={form[key]||""} onChange={e=>upF(key,e.target.value)} placeholder={placeholder}
        style={{background:T.bg,border:`1px solid ${errors[key]?T.danger:T.border}`,borderRadius:9,padding:"9px 12px",color:T.text,fontSize:14,outline:"none",width:"100%"}}/>
      {errors[key]&&<div style={{fontSize:11,color:T.danger,marginTop:3}}>⚠ {errors[key]}</div>}
    </div>
  );

  if (step==="done") return (
    <div style={{position:"fixed",inset:0,background:"rgba(8,12,30,0.22)",backdropFilter:"blur(4px)",zIndex:1001,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,padding:36,maxWidth:440,textAlign:"center"}}>
        <div style={{fontSize:56,marginBottom:14}}>✅</div>
        <div style={{fontSize:20,fontWeight:800,color:T.success,marginBottom:8}}>Fiche envoyée !</div>
        <div style={{fontSize:13,color:T.muted,marginBottom:6}}>La fiche de consigne a été transmise à :</div>
        <div style={{background:T.bg,borderRadius:10,padding:12,marginBottom:16,fontSize:12,color:T.text,lineHeight:1.8}}>
          📧 Télésurveillance : <strong>{form.email_telesurveillance}</strong><br/>
          📧 Client : <strong>{form.email_client||"—"}</strong>
        </div>
        <div style={{display:"flex",gap:10}}>
          <button onClick={openPDF} style={{flex:1,padding:"11px",borderRadius:10,background:T.accentDim,border:`1px solid ${T.accent}`,color:T.accent,fontSize:13,fontWeight:700,cursor:"pointer"}}>🖨️ Imprimer</button>
          <button onClick={onClose} style={{flex:1,padding:"11px",borderRadius:10,background:T.success,border:"none",color:"#fff",fontSize:13,fontWeight:700,cursor:"pointer"}}>Fermer</button>
        </div>
      </div>
    </div>
  );

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(8,12,30,0.22)",backdropFilter:"blur(4px)",zIndex:1001,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:T.card,border:`2px solid ${T.danger}`,borderRadius:16,boxShadow:"0 24px 80px rgba(0,0,0,0.18),0 8px 24px rgba(0,0,0,0.08)",width:680,maxHeight:"92vh",display:"flex",flexDirection:"column"}}>

        {/* Header */}
        <div style={{padding:"16px 22px 12px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0,background:`${T.danger}10`}}>
          <div>
            <div style={{fontSize:17,fontWeight:800,color:T.danger}}>🚨 Fiche de Consigne Télésurveillance</div>
            <div style={{fontSize:12,color:T.muted,marginTop:2}}>Pack Flash Control · {intervention.titre} · <strong style={{color:T.danger}}>CONFIDENTIEL</strong></div>
          </div>
          <div style={{display:"flex",gap:8}}>
            <button onClick={openPDF} style={{padding:"7px 13px",borderRadius:9,background:T.accentDim,border:`1px solid ${T.accent}`,color:T.accent,fontSize:12,fontWeight:700,cursor:"pointer"}}>🖨️ Aperçu PDF</button>
            <button onClick={onClose} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:22}}>✕</button>
          </div>
        </div>

        {/* Steps */}
        <div style={{display:"flex",borderBottom:`1px solid ${T.border}`,flexShrink:0}}>
          {[["form","📋 Informations"],["signatures","✍️ Signatures & Envoi"]].map(([k,l])=>(
            <button key={k} onClick={()=>k==="signatures"?validate()&&setStep(k):setStep(k)}
              style={{flex:1,padding:"10px",background:step===k?`${T.danger}15`:"transparent",border:"none",borderBottom:step===k?`2px solid ${T.danger}`:"2px solid transparent",color:step===k?T.danger:T.muted,fontSize:13,fontWeight:step===k?700:500,cursor:"pointer"}}>
              {l}
            </button>
          ))}
        </div>

        <div style={{flex:1,overflowY:"auto",padding:"16px 22px"}}>

          {step==="form"&&(
            <div style={{display:"flex",flexDirection:"column",gap:16}}>

              {/* Numéros client */}
              <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:12,padding:16}}>
                <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:12}}>📞 Numéros de contact client <span style={{color:T.danger,fontSize:11}}>(ordre d'appel)</span></div>
                <div style={{display:"flex",flexDirection:"column",gap:8}}>
                  {[["numero_client_1","1er contact (principal) *"],["numero_client_2","2ème contact"],["numero_client_3","3ème contact"]].map(([k,l])=>(
                    <div key={k}>
                      <label style={{fontSize:11,fontWeight:700,color:T.muted,display:"block",marginBottom:4,textTransform:"uppercase",letterSpacing:"0.5px"}}>{l}</label>
                      {inp(k,"Ex: 06 12 34 56 78","tel")}
                    </div>
                  ))}
                </div>
              </div>

              {/* Zones alarme */}
              <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:12,padding:16}}>
                <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:12,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span>🚨 Zones alarme</span>
                  <button onClick={()=>setZones(p=>[...p,{id:p.length+1,designation:"",localisation:"",type:"PIR",notes:""}])}
                    style={{padding:"5px 12px",borderRadius:8,background:`${T.danger}15`,border:`1px solid ${T.danger}30`,color:T.danger,fontSize:11,fontWeight:700,cursor:"pointer"}}>
                    + Zone
                  </button>
                </div>
                <div style={{overflowX:"auto"}}>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                    <thead>
                      <tr>{["Zone","Désignation","Localisation","Type","Notes",""].map(h2=>(
                        <th key={h2} style={{background:`${T.danger}15`,padding:"7px 9px",fontWeight:700,color:T.danger,textAlign:"left",border:`1px solid ${T.danger}25`,whiteSpace:"nowrap",fontSize:10}}>{h2}</th>
                      ))}</tr>
                    </thead>
                    <tbody>
                      {zones.map((z,i)=>(
                        <tr key={z.id}>
                          <td style={{padding:"4px 6px",border:`1px solid ${T.border}`,textAlign:"center",fontWeight:800,color:T.danger,width:40}}>{i+1}</td>
                          {[["designation","Ex: Entrée principale"],["localisation","Ex: Rez-de-chaussée"]].map(([k,ph])=>(
                            <td key={k} style={{padding:"4px 6px",border:`1px solid ${T.border}`}}>
                              <input value={z[k]||""} onChange={e=>setZones(p=>p.map((x,j)=>j===i?{...x,[k]:e.target.value}:x))} placeholder={ph}
                                style={{background:T.bg,border:"none",borderRadius:6,padding:"5px 8px",color:T.text,fontSize:12,outline:"none",width:"100%"}}/>
                            </td>
                          ))}
                          <td style={{padding:"4px 6px",border:`1px solid ${T.border}`}}>
                            <select value={z.type||"PIR"} onChange={e=>setZones(p=>p.map((x,j)=>j===i?{...x,type:e.target.value}:x))}
                              style={{background:T.bg,border:"none",borderRadius:6,padding:"5px 8px",color:T.text,fontSize:12,outline:"none",width:"100%"}}>
                              {["PIR","Contact","Rideau","Détecteur fumée","Sirène","Clavier","Hub","Autre"].map(t=><option key={t}>{t}</option>)}
                            </select>
                          </td>
                          <td style={{padding:"4px 6px",border:`1px solid ${T.border}`}}>
                            <input value={z.notes||""} onChange={e=>setZones(p=>p.map((x,j)=>j===i?{...x,notes:e.target.value}:x))} placeholder="Observations"
                              style={{background:T.bg,border:"none",borderRadius:6,padding:"5px 8px",color:T.text,fontSize:12,outline:"none",width:"100%"}}/>
                          </td>
                          <td style={{padding:"4px 6px",border:`1px solid ${T.border}`,textAlign:"center"}}>
                            {zones.length>1&&<button onClick={()=>setZones(p=>p.filter((_,j)=>j!==i))}
                              style={{background:"none",border:"none",color:"#ef4444",cursor:"pointer",fontSize:14}}>🗑</button>}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Codes */}
              <div style={{background:`${T.danger}08`,border:`1px solid ${T.danger}30`,borderRadius:12,padding:16}}>
                <div style={{fontSize:13,fontWeight:700,color:T.danger,marginBottom:12}}>🔐 Codes & Identifiants <span style={{fontSize:11,color:T.muted,fontWeight:400}}>(informations confidentielles)</span></div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
                  <div style={{gridColumn:"1/-1"}}>
                    <label style={{fontSize:11,fontWeight:700,color:T.muted,display:"block",marginBottom:4,textTransform:"uppercase",letterSpacing:"0.5px"}}>N° Transmetteur ★ OBLIGATOIRE</label>
                    {inp("numero_transmetteur","Numéro de transmetteur...")}
                  </div>
                  <div>
                    <label style={{fontSize:11,fontWeight:700,color:T.muted,display:"block",marginBottom:4,textTransform:"uppercase",letterSpacing:"0.5px"}}>Mot de passe télésurveilleur</label>
                    {inp("mot_de_passe_telesurveilleur","Code vocal...")}
                  </div>
                  <div>
                    <label style={{fontSize:11,fontWeight:700,color:T.muted,display:"block",marginBottom:4,textTransform:"uppercase",letterSpacing:"0.5px"}}>Code sous contrainte</label>
                    {inp("code_sous_contrainte","Code panic...")}
                  </div>
                </div>
              </div>

              {/* Horaires */}
              <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:12,padding:16}}>
                <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:12}}>🕐 Horaires d'activation / désactivation</div>
                <div style={{overflowX:"auto"}}>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                    <thead>
                      <tr>
                        {["Jour","Activation","Désactivation","Observations"].map(h2=>(
                          <th key={h2} style={{background:`${T.danger}15`,padding:"8px 10px",fontWeight:700,color:T.danger,textAlign:"left",border:`1px solid ${T.danger}30`,whiteSpace:"nowrap"}}>{h2}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {JOURS.map((j,i)=>(
                        <tr key={j}>
                          <td style={{padding:"6px 10px",border:`1px solid ${T.border}`,fontWeight:700,color:T.text,background:T.card,whiteSpace:"nowrap"}}>{JOURS_L[i]}</td>
                          <td style={{padding:"4px 6px",border:`1px solid ${T.border}`}}>
                            <input type="time" value={form.horaires[j]?.activation||""} onChange={e=>upH(j,"activation",e.target.value)}
                              style={{background:T.bg,border:"none",borderRadius:6,padding:"5px 8px",color:T.text,fontSize:12,outline:"none",width:"100%"}}/>
                          </td>
                          <td style={{padding:"4px 6px",border:`1px solid ${T.border}`}}>
                            <input type="time" value={form.horaires[j]?.desactivation||""} onChange={e=>upH(j,"desactivation",e.target.value)}
                              style={{background:T.bg,border:"none",borderRadius:6,padding:"5px 8px",color:T.text,fontSize:12,outline:"none",width:"100%"}}/>
                          </td>
                          <td style={{padding:"4px 6px",border:`1px solid ${T.border}`}}>
                            <input value={form.horaires[j]?.notes||""} onChange={e=>upH(j,"notes",e.target.value)} placeholder="ex: fermé"
                              style={{background:T.bg,border:"none",borderRadius:6,padding:"5px 8px",color:T.text,fontSize:12,outline:"none",width:"100%"}}/>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Emails */}
              <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:12,padding:16}}>
                <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:12}}>📧 Destinataires d'envoi</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
                  <div>
                    <label style={{fontSize:11,fontWeight:700,color:T.muted,display:"block",marginBottom:4,textTransform:"uppercase",letterSpacing:"0.5px"}}>Email télésurveillance *</label>
                    {inp("email_telesurveillance","telesurveillance@...","email")}
                  </div>
                  <div>
                    <label style={{fontSize:11,fontWeight:700,color:T.muted,display:"block",marginBottom:4,textTransform:"uppercase",letterSpacing:"0.5px"}}>Email client</label>
                    {inp("email_client","client@...","email")}
                  </div>
                </div>
              </div>
            </div>
          )}

          {step==="signatures"&&(
            <div style={{display:"flex",flexDirection:"column",gap:16}}>
              {/* Récap */}
              <div style={{background:`${T.danger}10`,border:`1px solid ${T.danger}30`,borderRadius:12,padding:14}}>
                <div style={{fontSize:12,fontWeight:700,color:T.danger,marginBottom:10,textTransform:"uppercase",letterSpacing:"0.5px"}}>📋 Récapitulatif avant envoi</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,fontSize:12}}>
                  {[["N° Transmetteur",form.numero_transmetteur,"🔴"],["1er contact",form.numero_client_1,"📞"],["Télésurveillance",form.email_telesurveillance,"📧"],["Client",form.email_client,"📧"]].map(([l,v,ic])=>(
                    <div key={l} style={{display:"flex",gap:6,alignItems:"center"}}>
                      <span>{ic}</span>
                      <span style={{color:T.muted}}>{l} :</span>
                      <strong style={{color:v?T.text:T.danger}}>{v||"⚠ Manquant"}</strong>
                    </div>
                  ))}
                </div>
              </div>

              <SignaturePad T={T} label="✍️ Signature du technicien GS-GROUP"
                hint="Je certifie avoir installé et configuré le système conformément à cette fiche"
                value={form.signature_technicien} onChange={v=>upF("signature_technicien",v)}/>

              <SignaturePad T={T} label="🖊️ Signature du client / responsable"
                hint="Le client valide les informations de la présente fiche de consigne"
                value={form.signature_client} onChange={v=>upF("signature_client",v)}/>

              <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:12,fontSize:11,color:T.muted,lineHeight:1.7}}>
                📄 En validant, cette fiche sera automatiquement envoyée à la télésurveillance ({form.email_telesurveillance})
                {form.email_client&&` et au client (${form.email_client})`}. Le document est confidentiel.
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{padding:"12px 22px",borderTop:`1px solid ${T.border}`,display:"flex",gap:10,flexShrink:0}}>
          {step==="form"&&(
            <>
              <button onClick={()=>save(false)} disabled={saving}
                style={{flex:1,padding:"11px",borderRadius:10,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,fontSize:13,fontWeight:600,cursor:"pointer"}}>
                {saved?"✅ Sauvegardé":"💾 Sauvegarder brouillon"}
              </button>
              <button onClick={()=>validate()&&setStep("signatures")}
                style={{flex:2,padding:"11px",borderRadius:10,background:T.danger,border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer"}}>
                ✍️ Suivant → Signatures & Envoi
              </button>
            </>
          )}
          {step==="signatures"&&(
            <>
              <button onClick={()=>setStep("form")} style={{flex:1,padding:"11px",borderRadius:10,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,fontSize:13,cursor:"pointer"}}>← Retour</button>
              <button onClick={()=>save(true)} disabled={saving||!form.signature_technicien||!form.signature_client||!form.numero_transmetteur}
                style={{flex:2,padding:"11px",borderRadius:10,background:form.signature_technicien&&form.signature_client&&form.numero_transmetteur?`linear-gradient(135deg,${T.danger},#dc2626)`:T.border,border:"none",color:"#fff",fontSize:14,fontWeight:800,cursor:"pointer",opacity:saving?0.7:1}}>
                {saving?"Envoi en cours...":"🚨 Valider & Envoyer à la télésurveillance"}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
